import React from 'react';
import Element from '../../components/element';
import { ReactComponent as IconConnectionLost } from '../../assets/icons/IconConnectionLost.svg';
import useStyles from './style';
import Button from '../Button';

const ConnectionLost = () => {
  const classes = useStyles();
  return (
    <div>
      <section
        className={classes.dropBoxContainer}
        style={{ cursor: 'pointer' }}
        draggable={true}
      >
        <div>
          <div className={classes.childContainer}>
            <Element
              type={IconConnectionLost}
              className={classes.connectionLostIcon}
            />
          </div>
          <div>
            <label className={classes.header}>Connection Lost</label>
          </div>
          <div>
            <label className={classes.description}>
              Please check your connection and try again
            </label>
          </div>
          <div className={classes.button}>
            <Button
              scheme="dark"
              onClick={() => {
                window.location.reload();
              }}
            >
              Refresh
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ConnectionLost;
